import { initialState } from '..'
import {
  ADD_PRODUCT_FAIL,
  ADD_PRODUCT_SUCCESS,
  ADD_PRODUCT,
  PURGE_BASKET,
  REBUILD_WEBSHOP,
  SET_BASKET_PRODUCTS,
  SET_PACKAGES,
  GET_BASKET,
  GET_BASKET_SUCCESS,
  REMOVE_PRODUCT_FROM_BASKET,
  REMOVE_PRODUCT_FROM_BASKET_SUCCESS,
  SET_HIDDEN_PACKAGES,
} from '../../actions/webshop/webshop'

import type { WebshopActions } from '../../actions/webshop/webshop'
import { WebshopPackage } from '../../../schema/webshop-package'
import { BasketItem } from '../../../schema/basket'

export type RequestStatus = 'pending' | 'success' | 'error' | 'cancelled' | ''

export type WebshopStoreType = {
  inOrder: Array<BasketItem> // products that are placed in the basket
  vatTotal: number, // total vat of basket
  packages: Array<WebshopPackage>
  hiddenPackages: Array<WebshopPackage>
  status: RequestStatus
  getBasket: RequestStatus
  removeProduct: {
    product?: WebshopPackage
    status: RequestStatus
  }
}

const reducer = (
  state: WebshopStoreType,
  action: WebshopActions,
): WebshopStoreType => {
  if (!state) return initialState.webshop

  switch (action.type) {
    case ADD_PRODUCT:
      return {
        ...state,
        status: 'pending',
      }

    case ADD_PRODUCT_SUCCESS:
    case REBUILD_WEBSHOP:
      return {
        ...state,
        status: 'success',
      }

    case ADD_PRODUCT_FAIL:
      return {
        ...state,
        status: 'error',
      }

    case REMOVE_PRODUCT_FROM_BASKET:
      return {
        ...state,
        removeProduct: {
          product: action.payload,
          status: 'pending'
        }
      }

    case REMOVE_PRODUCT_FROM_BASKET_SUCCESS:
      return {
        ...state,
        removeProduct: {
          ...state.removeProduct,
          status: 'success'
        }
      }

    case GET_BASKET:
      return {
        ...state,
        getBasket: 'pending',
      }

    case GET_BASKET_SUCCESS:
      return {
        ...state,
        getBasket: 'success',
        inOrder: action.payload.items,
        vatTotal: action.payload.vatTotal,
        status: '',
      }

    case SET_PACKAGES:
      return {
        ...state,
        packages: action.payload,
      }

    case SET_HIDDEN_PACKAGES:
      return {
        ...state,
        hiddenPackages: action.payload,
      }

    case SET_BASKET_PRODUCTS:
      return {
        ...state,
        inOrder: action.payload,
        status: '',
      }

    case PURGE_BASKET:
      return {
        ...state,
        inOrder: [],
        vatTotal: 0,
        status: '',
      }

    default:
      return state
  }
}

export default reducer
